var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBRipleyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "120px",
    height: "30px",
    viewBox: "0 0 120 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 74.449219 0.996094 C 75.566406 0.796875 76.300781 1.230469 76.65625 2.296875 C 76.714844 3.769531 76.007812 4.449219 74.535156 4.335938 C 73.273438 3.761719 72.972656 2.851562 73.625 1.605469 C 73.867188 1.347656 74.140625 1.144531 74.449219 0.996094 Z M 74.449219 0.996094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 1.253906 1.34375 C 2.140625 1.316406 3.019531 1.34375 3.894531 1.429688 C 3.921875 2.847656 3.949219 4.261719 3.980469 5.679688 C 6.605469 4.894531 8.855469 5.5 10.726562 7.5 C 12.0625 9.394531 12.351562 11.449219 11.59375 13.65625 C 10.316406 16.371094 8.167969 17.597656 5.148438 17.339844 C 3.777344 17.230469 2.464844 16.898438 1.210938 16.34375 C 1.140625 11.335938 1.152344 6.335938 1.253906 1.34375 Z M 5.40625 7.847656 C 7.78125 7.8125 9.023438 8.984375 9.128906 11.359375 C 9.058594 13.503906 7.964844 14.675781 5.839844 14.871094 C 5.222656 14.820312 4.617188 14.703125 4.023438 14.523438 C 3.90625 12.414062 3.90625 10.304688 4.023438 8.195312 C 4.488281 8.042969 4.949219 7.929688 5.40625 7.847656 Z M 5.40625 7.847656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 91.320312 1.429688 C 92.242188 1.429688 93.164062 1.429688 94.089844 1.429688 C 94.089844 6.605469 94.089844 11.777344 94.089844 16.949219 C 93.164062 16.949219 92.242188 16.949219 91.320312 16.949219 C 91.320312 11.777344 91.320312 6.605469 91.320312 1.429688 Z M 91.320312 1.429688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 16.914062 5.332031 C 18.164062 5.222656 19.375 5.382812 20.546875 5.808594 C 21.90625 6.507812 22.699219 7.621094 22.925781 9.148438 C 22.984375 11.257812 22.984375 13.367188 22.925781 15.476562 C 22.417969 16.015625 21.886719 16.519531 21.328125 16.996094 C 19.546875 17.390625 17.757812 17.445312 15.960938 17.167969 C 13.402344 16.558594 12.347656 14.953125 12.804688 12.355469 C 13.144531 11.292969 13.820312 10.527344 14.835938 10.058594 C 16.585938 9.453125 18.359375 9.351562 20.160156 9.753906 C 20.160156 8.6875 19.628906 8.066406 18.558594 7.890625 C 17.34375 7.777344 16.1875 7.996094 15.097656 8.539062 C 15.015625 8.53125 14.945312 8.503906 14.882812 8.453125 C 14.570312 7.917969 14.28125 7.371094 14.015625 6.804688 C 13.957031 6.691406 13.957031 6.574219 14.015625 6.460938 C 14.90625 5.867188 15.875 5.492188 16.914062 5.332031 Z M 17.605469 12.007812 C 18.449219 12.042969 19.285156 12.128906 20.117188 12.269531 C 20.203125 13.019531 20.230469 13.769531 20.203125 14.523438 C 18.996094 14.847656 17.785156 14.894531 16.566406 14.652344 C 15.625 14.253906 15.382812 13.605469 15.832031 12.703125 C 16.347656 12.257812 16.9375 12.023438 17.605469 12.007812 Z M 17.605469 12.007812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 82.40625 5.332031 C 84.691406 5.109375 86.609375 5.832031 88.160156 7.5 C 89.464844 9.328125 89.78125 11.320312 89.113281 13.484375 C 88.164062 15.789062 86.449219 17.074219 83.964844 17.339844 C 83.089844 17.421875 82.238281 17.324219 81.414062 17.039062 C 81.371094 18.394531 81.355469 19.753906 81.371094 21.113281 C 80.453125 21.140625 79.546875 21.113281 78.644531 21.027344 C 78.585938 16.140625 78.585938 11.257812 78.644531 6.371094 C 79.855469 5.828125 81.109375 5.480469 82.40625 5.332031 Z M 82.839844 7.847656 C 85.582031 7.921875 86.808594 9.339844 86.519531 12.09375 C 86.167969 13.875 85.085938 14.800781 83.273438 14.871094 C 82.65625 14.820312 82.046875 14.703125 81.457031 14.523438 C 81.339844 12.414062 81.339844 10.304688 81.457031 8.195312 C 81.921875 8.046875 82.382812 7.933594 82.839844 7.847656 Z M 82.839844 7.847656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 100.578125 5.332031 C 103.933594 5.230469 105.96875 6.820312 106.675781 10.101562 C 106.734375 10.5625 106.734375 11.027344 106.675781 11.488281 C 106.285156 11.878906 105.898438 12.269531 105.507812 12.660156 C 103.257812 12.703125 101.007812 12.714844 98.761719 12.703125 C 99.300781 14.175781 100.371094 14.898438 101.960938 14.871094 C 102.886719 14.84375 103.722656 14.570312 104.46875 14.046875 C 104.554688 13.988281 104.644531 13.988281 104.730469 14.046875 C 105.058594 14.664062 105.375 15.285156 105.679688 15.910156 C 105.613281 16.136719 105.46875 16.296875 105.25 16.386719 C 102.835938 17.738281 100.441406 17.707031 98.066406 16.300781 C 96.0625 14.605469 95.324219 12.449219 95.863281 9.839844 C 96.414062 7.25 97.984375 5.746094 100.578125 5.332031 Z M 100.921875 7.847656 C 102.484375 7.894531 103.4375 8.6875 103.777344 10.230469 C 102.074219 10.289062 100.375 10.289062 98.671875 10.230469 C 98.941406 8.964844 99.695312 8.167969 100.921875 7.847656 Z M 100.921875 7.847656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 108.277344 5.332031 C 109.191406 5.304688 110.101562 5.332031 111.003906 5.417969 C 111.003906 7.648438 111.0625 9.875 111.175781 12.09375 C 111.695312 13.203125 112.574219 13.753906 113.8125 13.742188 C 114.519531 13.699219 115.210938 13.585938 115.890625 13.394531 C 115.960938 10.738281 116.003906 8.078125 116.019531 5.417969 C 116.921875 5.332031 117.832031 5.304688 118.746094 5.332031 C 118.761719 9.175781 118.746094 13.019531 118.703125 16.863281 C 118.179688 18.976562 116.871094 20.320312 114.765625 20.894531 C 112.816406 21.371094 110.96875 21.109375 109.230469 20.117188 C 109.023438 20.027344 108.882812 19.882812 108.796875 19.683594 C 109.074219 19.007812 109.421875 18.371094 109.835938 17.773438 C 110.5625 18.132812 111.34375 18.394531 112.171875 18.554688 C 114.179688 18.835938 115.449219 18.011719 115.976562 16.082031 C 114.617188 16.316406 113.261719 16.304688 111.910156 16.039062 C 109.90625 15.503906 108.707031 14.21875 108.320312 12.183594 C 108.277344 9.898438 108.261719 7.617188 108.277344 5.332031 Z M 108.277344 5.332031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 28.421875 5.417969 C 30.28125 5.160156 31.980469 5.550781 33.527344 6.589844 C 34.457031 7.402344 34.992188 8.429688 35.125 9.667969 C 35.183594 12.066406 35.183594 14.464844 35.125 16.863281 C 34.226562 16.949219 33.316406 16.980469 32.402344 16.949219 C 32.441406 14.519531 32.398438 12.089844 32.269531 9.667969 C 31.820312 8.453125 30.941406 7.875 29.632812 7.933594 C 28.921875 7.957031 28.226562 8.085938 27.554688 8.324219 C 27.5 8.390625 27.457031 8.460938 27.425781 8.539062 C 27.382812 11.34375 27.367188 14.148438 27.382812 16.949219 C 26.46875 16.980469 25.558594 16.949219 24.65625 16.863281 C 24.601562 13.425781 24.601562 9.984375 24.65625 6.546875 C 24.691406 6.46875 24.734375 6.394531 24.789062 6.328125 C 25.984375 5.917969 27.195312 5.617188 28.421875 5.417969 Z M 28.421875 5.417969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 41.570312 5.417969 C 43.070312 5.253906 44.484375 5.527344 45.8125 6.242188 C 46.011719 6.355469 46.183594 6.5 46.332031 6.675781 C 46.035156 7.324219 45.71875 7.960938 45.378906 8.582031 C 45.046875 8.550781 44.730469 8.433594 44.425781 8.238281 C 42.503906 7.53125 40.960938 8.007812 39.796875 9.667969 C 38.917969 11.648438 39.367188 13.253906 41.140625 14.480469 C 42.554688 15.089844 43.910156 14.972656 45.207031 14.132812 C 45.316406 14.074219 45.417969 14.089844 45.507812 14.175781 C 45.773438 14.738281 46.0625 15.289062 46.375 15.824219 C 46.429688 15.9375 46.429688 16.054688 46.375 16.171875 C 44.523438 17.441406 42.519531 17.746094 40.359375 17.082031 C 37.464844 15.832031 36.183594 13.621094 36.511719 10.449219 C 37.097656 7.648438 38.785156 5.972656 41.570312 5.417969 Z M 41.570312 5.417969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 51.347656 5.417969 C 54.714844 5.175781 56.921875 6.648438 57.96875 9.839844 C 58.542969 12.5625 57.75 14.773438 55.585938 16.472656 C 53.894531 17.449219 52.105469 17.652344 50.222656 17.082031 C 48.183594 16.1875 46.957031 14.640625 46.546875 12.441406 C 46.207031 9.753906 47.144531 7.660156 49.359375 6.15625 C 49.996094 5.8125 50.660156 5.566406 51.347656 5.417969 Z M 51.78125 7.933594 C 53.691406 7.902344 54.832031 8.824219 55.199219 10.707031 C 55.414062 12.113281 55.023438 13.3125 54.03125 14.304688 C 52.339844 15.304688 50.941406 15.003906 49.835938 13.394531 C 48.953125 11.5 49.253906 9.839844 50.742188 8.410156 C 51.085938 8.222656 51.433594 8.0625 51.78125 7.933594 Z M 51.78125 7.933594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 67.699219 5.417969 C 69.101562 5.285156 70.457031 5.472656 71.765625 5.984375 C 72.015625 6.0625 72.21875 6.207031 72.371094 6.417969 C 72.140625 7.085938 71.921875 7.765625 71.722656 8.453125 C 71.679688 8.542969 71.605469 8.601562 71.507812 8.628906 C 70.164062 7.820312 68.78125 7.730469 67.355469 8.367188 C 67.265625 11.226562 67.238281 14.089844 67.265625 16.949219 C 66.351562 16.980469 65.445312 16.949219 64.542969 16.863281 C 64.46875 13.367188 64.484375 9.871094 64.585938 6.371094 C 65.589844 5.910156 66.628906 5.59375 67.699219 5.417969 Z M 67.699219 5.417969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20%,47.45098%)",
      fillOpacity: 1
    },
    d: "M 73.667969 5.851562 C 74.5625 5.851562 75.457031 5.851562 76.351562 5.851562 C 76.351562 9.550781 76.351562 13.25 76.351562 16.949219 C 75.4375 16.980469 74.527344 16.949219 73.625 16.863281 C 73.554688 13.1875 73.570312 9.515625 73.667969 5.851562 Z M 73.667969 5.851562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588235%,15.294118%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 91.578125 24.839844 C 91.578125 26.199219 91.578125 27.558594 91.578125 28.917969 C 82.640625 28.929688 73.699219 28.917969 64.757812 28.871094 C 64.679688 28.839844 64.605469 28.796875 64.542969 28.742188 C 64.484375 27.5 64.484375 26.257812 64.542969 25.015625 C 64.585938 24.972656 64.628906 24.929688 64.671875 24.882812 C 73.640625 24.839844 82.609375 24.828125 91.578125 24.839844 Z M 91.578125 24.839844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(97.647059%,70.196078%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 91.578125 24.839844 C 94.320312 24.839844 97.058594 24.839844 99.796875 24.839844 C 99.796875 26.199219 99.796875 27.558594 99.796875 28.917969 C 97.058594 28.917969 94.320312 28.917969 91.578125 28.917969 C 91.578125 27.558594 91.578125 26.199219 91.578125 24.839844 Z M 91.578125 24.839844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.901961%,28.235294%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 99.796875 24.839844 C 106.054688 24.828125 112.316406 24.839844 118.574219 24.882812 C 118.742188 26.179688 118.800781 27.492188 118.746094 28.828125 C 112.433594 28.914062 106.117188 28.945312 99.796875 28.917969 C 99.796875 27.558594 99.796875 26.199219 99.796875 24.839844 Z M 99.796875 24.839844 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBRipleyLogo);
export default __webpack_public_path__ + "static/media/BRipley-logo.91ad22f3a8e538d0b87982c9cb52217a.svg";
export { ForwardRef as ReactComponent };